import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";

import "./DashboardPage.scss";
import DashboardHeader from "../../components/dashboard-page/sections/DashboardHeader/DashboardHeader";
import DashboardHeroSection from "../../components/dashboard-page/sections/DashboardHeroSection/DashboardHeroSection";
import PendingGameEntriesSection from "../../components/dashboard-page/sections/PendingGameEntriesSection/PendingGameEntriesSection";
import StreaksSection from "../../components/dashboard-page/sections/StreaksSection/StreaksSection";
import MostPopularGamesSection from "../../components/dashboard-page/sections/MostPopularGamesSection/MostPopularGamesSection";
import LiveMultiplayerTournamentsSection from "../../components/dashboard-page/sections/LiveMultiplayerTournamentsSection/LiveMultiplayerTournamentsSection";
import AgeRestrictionModal from "../../components/AgeRestrictionModal/AgeRestrictionModal";
import useDisclosure from "../../hooks/useDisclosure";
import {
  getStoredHasShownAgeRestrictionNotice,
  setStoredHasShownAgeRestrictionNotice,
} from "../../utils/storage";
import AllGamesSection from "../../components/dashboard-page/sections/AllGamesSection/AllGamesSection";
import { renderHeaders } from "../../utils/renderHeaders";
import ChallengeFriendsModal from "../../components/modals/ChallengeFriendsModal/ChallengeFriendsModal";
import ChallengesSection from "../../components/dashboard-page/sections/ChallengesSection/ChallengesSection";
import useUserVerificationStatusQuery from "../../react-query/queries/use-user-verification-status";

function DashboardPage() {
  const { t } = useTranslation(["dashboard", "metadata"]);
  const { isLegalAge } = useUserVerificationStatusQuery();
  const {
    isOpen: isAgeRestrictionOpen,
    onOpen: openAgeRestriction,
    onClose: closeAgeRestriction,
  } = useDisclosure();

  const onShowAgeModal = useCallback(() => {
    const hasShownAgeRestrictionNotice =
      getStoredHasShownAgeRestrictionNotice();
    if (isLegalAge === undefined || hasShownAgeRestrictionNotice) return;

    if (!isLegalAge) {
      openAgeRestriction();
      setStoredHasShownAgeRestrictionNotice(true);
    }
  }, [isLegalAge, openAgeRestriction]);

  return (
    <>
      {renderHeaders({
        title: t("dashboard_page_title"),
        description: t("metadata:dashboard_seo_description"),
        ogTitle: t("dashboard_page_og_title"),
      })}
      <main className="dashboard-page MobileOnly">
        <DashboardHeader />
        <DashboardHeroSection />
        <PendingGameEntriesSection />
        <ChallengesSection />
        <StreaksSection />
        <MostPopularGamesSection />
        <LiveMultiplayerTournamentsSection />
        <AllGamesSection />
      </main>

      <AgeRestrictionModal
        isOpen={isAgeRestrictionOpen}
        onClose={closeAgeRestriction}
      />
      <ChallengeFriendsModal onShowModalComplete={onShowAgeModal} />
    </>
  );
}

export default DashboardPage;
